import { SchoolPage_school } from 'main/pages/School/gql'
import { IPricingRange, profileEnrollmentPricing } from 'main/util/profile'

export function tuitionPriceRange(school: SchoolPage_school): IPricingRange | null {
  const enrollment = school.profile && school.profile.enrollment

  return profileEnrollmentPricing(enrollment)
}
